import { render, staticRenderFns } from "./shoushi_project3.vue?vue&type=template&id=fef33d76&"
import script from "./shoushi_project3.vue?vue&type=script&lang=js&"
export * from "./shoushi_project3.vue?vue&type=script&lang=js&"
import style0 from "./shoushi_project3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports